module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("DARKNESS RISING")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe.page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "p0022-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter3d#hc6",
      "id": "ch6"
    }
  }, [_vm._v("3.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx100",
    attrs: {
      "id": "p0022-02-1"
    }
  }, [_c('span', [_vm._v("There were rows of folding chairs in the main gallery, but not enough for all the guests. Dani and Tommy stood on the side with their backs to the windows, close to the door. Behind a portable podium at the far end of the room they could see a curtain concealing what Dani assumed was the main attraction, the painting known as "), _c('i', [_vm._v("The Garden of Earthly Delights")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-02-1a"
    }
  }, [_c('span', [_vm._v("The headmaster took the podium.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-02-2"
    }
  }, [_c('span', [_vm._v("After a few seconds of polite applause, Wharton glanced briefly at his notes, then removed his reading glasses to speak from memory.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-02-3"
    }
  }, [_c('span', [_vm._v("“We are all here,” he began, “because of a gift. The paintings and drawings you see on the walls around you, or will see when the lights come up, and in particular the special painting behind this curtain”—he gestured over his shoulder—“are of course not gifts. Would that they were . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-02-4"
    }
  }, [_c('span', [_vm._v("“I’ll never understand how Americans like Orson Welles or William F. Buckley or this guy end up with British accents,” Tommy whispered.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-02-5"
    }
  }, [_c('span', [_vm._v("“They have been generously loaned to us,” Wharton continued, “by one of our most esteemed alumni, Herr Udo Bauer. His continued support for St. Adrian’s Academy and its mission has been a precious gift indeed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-02-6"
    }
  }, [_c('span', [_vm._v("“Esteemed?” Tommy said to Dani over another round of applause. “He’s forgetting the part where Bauer’s grandfather tested his drugs in Nazi concentration camps.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("“Allegedly,” Dani said. The research they’d done before the exhibition had turned up a few accusations but nothing conclusive.")])])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-01-1"
    }
  }, [_c('span', [_vm._v("“Right,” Tommy said. “And the sun ‘allegedly’ rose in the east this morning.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-01-2"
    }
  }, [_c('span', [_vm._v("“I had in mind,” Wharton said, “to ask Udo, class of ’77, to say a few words tonight, but he’s far too modest and asked that I not force him to speak. I will instead announce, on his behalf, that in addition to loaning the paintings from his family’s collection, he has also seen fit to make a contribution to the school’s development fund for a new science facility. It will be, simply, the finest of any preparatory school in the world.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-01-3"
    }
  }, [_c('span', [_vm._v("“What’s wrong with the one they have?” Dani asked Tommy over the next round of applause. “I thought they just built one ten years ago.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-01-4"
    }
  }, [_c('span', [_vm._v("“Toward that end,” Wharton continued, “fifteen minutes ago, Udo Bauer handed me a check. This one . . .” He pulled a check from his shirt pocket and held it up. “For the sum of . . .” He paused for effect. “One hundred million dollars.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-01-5"
    }
  }, [_c('span', [_vm._v("There was a collective gasp, then thunderous applause that didn’t stop until Bauer stood and nodded to the crowd.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-01-6"
    }
  }, [_c('span', [_vm._v("“That’s going to buy a lot of frogs to dissect,” Tommy said.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-01-7"
    }
  }, [_c('span', [_vm._v("“We will, of course, keep our alumni informed as the building progresses,” Wharton said once the applause died away. “Now, to tell you about the paintings you are about to see, I give you the distinguished art historian, antiquities curator at the Ashmolean Museum in Oxford, England, don emeritus of Trinity College, University of Oxford, and the world’s leading authority on Heironymus Bosch—ladies and gentlemen, Dr. Julian Villanegre.”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-01-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("As the crowd welcomed Dr. Villanegre, a large screen lowered from the ceiling and the lights came down even further, save for a spotlight on the podium. Julian Villanegre smiled broadly, adjusting the microphone and thanking the headmaster. He paused, waiting for the audience’s complete attention. Dani thought again of how he’d looked at her.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v(" Something about him defied understanding, something . . . mystical? Was that the word?")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-01-1"
    }
  }, [_c('span', [_vm._v("“For the first time,” he began, “one of the world’s most breathtaking—and most misunderstood—paintings has come to America. Heironymus Bosch, born 1450, died 1516 . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-01-2"
    }
  }, [_c('span', [_vm._v("A self-portrait of the artist appeared on the screen. He looked kind, avuncular. He’d grown up in the town of Hertogenbosch, Villanegre said, in the Duchy of Brabant, a region that today would include parts of Holland and Belgium.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-01-3"
    }
  }, [_c('span', [_vm._v("“Hertogenbosch, we note, burned to the ground in 1463. The artist, who would have been about thirteen, was suspected of setting the fires. It’s thought that his famous ‘hellscapes’ may have been his way of imaginatively revisiting the scene of the crime.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-01-4"
    }
  }, [_c('span', [_vm._v("“Sounds a lot like Amos Kasden,” Tommy whispered.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-01-5"
    }
  }, [_c('span', [_vm._v("The slide of the artist faded to black, and then a slide of "), _c('i', [_vm._v("The Garden of Earthly Delights ")]), _vm._v("faded in.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-01-6"
    }
  }, [_c('span', [_vm._v("Villanegre paused to let the image of the painting register. The room fell silent.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-01-7"
    }
  }, [_c('span', [_vm._v("Dani listened closely as Villanegre briefly reviewed the function of paintings in the Renaissance, before movies, television, or photography. "), _c('i', [_vm._v("The Garden of Earthly Delights ")]), _vm._v("was a triptych, with the two outer rectangular panels hinged to fold over the square center panel like shutters. "), _c('i', [_vm._v("The Garden of Earthly Delights")]), _vm._v(", or "), _c('i', [_vm._v("The Millennium")]), _vm._v(", as it was also known, was, like most altarpieces, intended to be a pedagogic tool mounted above the altar in a church to illustrate spiritual texts, usually Bible stories.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-01-8"
    }
  }, [_c('span', [_vm._v("“But that’s where the enigma begins,” Villanegre said, “because it’s difficult to imagine what kind of church might have commissioned this one. One cannot say with certainty whom Bosch was working for when he created his extraordinary vision. He left no written record of his thoughts regarding the painting. The work must speak for itself. But what does it say?”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("He explained that altarpieces were meant to be read from left to right. In "), _c('i', [_vm._v("The Millennium")]), _vm._v(", the left panel depicted the Garden of Eden, the middle panel represented life on Earth, and the right-hand panel depicted hell. Villanegre directed the audience to the center of the left panel, where God presented Eve to Adam.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-01-1"
    }
  }, [_c('span', [_vm._v("“Adam has an astonished expression, as one might expect,” Villanegre said, using his laser pointer to circle Adam’s face. “And yet even in paradise, things have begun to go wrong. We see the snake, familiar to readers of Genesis, but also a two-legged dog . . . a three-headed salamander . . . here a duck with teeth . . . and here a duck reading a book. Given that Eden is where man was born, we may consider these to prefigure knowledge of birth defects . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-01-2"
    }
  }, [_c('span', [_vm._v("“Or genetic disorders,” Dani whispered to Tommy.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-01-3"
    }
  }, [_c('span', [_vm._v("“The center panel teems with Adam-and-Eve-like figures, cavorting in twos and threes and fours, engaged in a variety of sexualized behaviors.” Villanegre continued to use the laser to highlight people on the screen behind him. “Here . . . here . . . and here . . . We note that in each group, one man has some sort of oversized piece of fruit on his head, symbolic of organic or natural wisdom. The ones with fruit on their heads are the instructors. But nothing in the painting is simple. You’ll see that the creatures in the panel are hybrids, blending animal, vegetable, and mineral. The architecture is also hybrid, where man-made constructions look like caves and boats are half fish. All is in flux, midtransformation, with opposites in union.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-01-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“The question over the centuries,” Villanegre continued, “has been whether the artist is condoning or condemning these behaviors. Is it a portrait of paradise on earth, where man has returned to an antelapsarian state of grace? Or is it a scathing depiction of human folly, where man, exalting himself above God, lives purely for the pleasures of the flesh? Ecstatic utopian vision, or nightmarish phantasmagoria? In the hellscape, filling the right-most panel, we see how God will punish those committing the seven")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v(" deadly sins, with gluttony represented by this figure here, condemned to an eternity of dyspepsia . . . and sloth . . . and avarice . . .”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-01-1"
    }
  }, [_c('span', [_vm._v("“Wait here,” Tommy whispered. “I should be back in ten or fifteen minutes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-01-2"
    }
  }, [_c('span', [_vm._v("“I’m coming with you,” Dani said.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-01-3"
    }
  }, [_c('span', [_vm._v("“Bad idea. If they catch me, I’m just another dumb jock with a sense of entitlement who’s had too much to drink. It’s the 98 percent of all jocks who give the other 2 percent a bad name.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-01-4"
    }
  }, [_c('span', [_vm._v("Dani smiled, even though she’d come to understand something about Tommy Gunderson: he made jokes when he was afraid.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-01-5"
    }
  }, [_c('span', [_vm._v("“I’ll be back in ten. Fifteen tops. If I’m not . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-01-6"
    }
  }, [_c('span', [_vm._v("“What?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-01-7"
    }
  }, [_c('span', [_vm._v("“I don’t know. Pull the fire alarm or something. And then go home. One of us has to make it out of here. Don’t come looking for me. Promise?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-01-8"
    }
  }, [_c('span', [_vm._v("“Promise,” she said, then watched as he sidled toward the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "p_26_-9"
    }
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Ilf_9781595549457_INT_0026_002.gif",
      "src": "images/Ilf_9781595549457_INT_0026_002.gif"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx100",
    attrs: {
      "id": "p0026-03-10"
    }
  }, [_c('span', [_vm._v("“The key,” Villanegre was saying, “may be deciphering this figure in the lower right-hand corner of the center panel.” The laser pointer circled a man who appeared to be emerging from a cave. “This area, we know, is where artists of the period commonly inserted cameos of their patrons. One of the more compelling theories comes from the Swiss historian Viktor Friedrichs, who makes a strong case that the painting was commissioned by a pagan cult led by the Duke of Ghent, a patron of the arts who was later put to death for heresy. The provenance of the painting is not known, but it is believed to have hung in the duke’s private chapel.”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-03-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Villanegre let his laser pointer pause on a vaguely defined man beside the duke. Dani tried to concentrate on the lecture, which she found fascinating despite the odd, even sinister circumstances of the painting’s arrival. She tapped the screen on her phone, went to her apps and then to")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v(" her stopwatch application. She’d give Tommy fifteen minutes, and then she was going to look for him despite her promise.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-01-1"
    }
  }, [_c('span', [_vm._v("“Even more mysterious is this fellow here,” Villanegre said, “lurking in the shadows. He appears to be whispering something in the other man’s ear, serving as either a friendly advisor or, according to Friedrichs, as his Rasputin, his dark priest.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-01-2"
    }
  }, [_c('span', [_vm._v("Dani studied the projection of the painting. They’d come to look for anything out of the ordinary, and Heironymus Bosch’s painting was as far from “ordinary” as anything she could think of. A celebration of evil, a nightmarish vision of psychotic content, and clearly, in any day or age, the product of a profoundly disturbed imagination. This was a “pedagogic tool”?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-01-3"
    }
  }, [_c('span', [_vm._v("Was that why it had been brought here? To be used, once more, to teach?")])]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "p_27_-4"
    }
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Ilf_9781595549457_INT_0027_002.gif",
      "src": "images/Ilf_9781595549457_INT_0027_002.gif"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx100",
    attrs: {
      "id": "p0027-03-5"
    }
  }, [_c('span', [_vm._v("Tommy held up his cell phone to the man at the door to indicate he had an important call to make. “My dad isn’t well,” he whispered. That much was the truth. He closed the door noiselessly behind him and stepped out onto the patio, where he pretended to make a call, aware that the man at the door was watching him through the window. He looked up at the sky, then held his phone out at arm’s length, pantomiming that he was unable to find a spot with adequate cell tower coverage. It was a common problem in East Salem, where no one wanted a cell tower in his own backyard. Holding his phone out in front of him, he wandered away from the museum and into the darkness. When he glanced behind him, he saw he was no longer being observed.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-03-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("He moved quickly now, crossing the quad to the main building, where he found a door at the west end. The door was locked, opening only with a key card. Part of Tommy’s training to become a private detective included private lessons in lock picking with an ex-con he’d met through his talent")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v(" agency, but the lessons hadn’t covered electronic card locks. He moved to the rear of the building, staying in the shadows. The lights were out in the library wing, the stacks lined up inside like black tombstones. The back door accessing the rear parking lot was locked as well. The windows seemed formidable. The basement window wells had iron bars over them. The only way in was through the front door.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-01-1"
    }
  }, [_c('span', [_vm._v("Tommy was prepared to say he was looking for the men’s room, but discovered on entering the foyer and the domed great hall that no one was around. He listened, thinking there would at least be a switchboard operator or a night watchman afoot. His luck held. Everyone seemed to be at the museum. The soft rubber soles of his black cross-trainers, which he was wearing only because at the time he was dressing he couldn’t find his one pair of dress shoes, made his footsteps silent on the parquet floor.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-01-2"
    }
  }, [_c('span', [_vm._v("He walked quickly down the hall, past the library, and made his way to the school psychologist’s office. He listened. Nothing. The door to the waiting room was unlocked. When he closed the door behind him, the windowless room was plunged into total darkness.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-01-3"
    }
  }, [_c('span', [_vm._v("Tommy tapped on his phone for his flashlight app.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-01-4"
    }
  }, [_c('span', [_vm._v("He crossed to Ghieri’s office door. This one was locked, the mechanism again controlled with a magnetic key card. Breaking either the lock or the door or both was not an option, assuming it was even possible.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-01-5"
    }
  }, [_c('span', [_vm._v("He draped the listening device around his neck to free his hands, opened his phone’s slide-out keyboard, and went to the Google search box, where he typed "), _c('i', [_vm._v("How can you pick an electronic keycard lock? ")]), _vm._v("He’d just reached the results screen when the lights came on.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-01-6"
    }
  }, [_c('span', [_vm._v("Adolf Ghieri stood by the door, his hand on the light switch.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-01-7"
    }
  }, [_c('span', [_vm._v("“Oh, "), _c('i', [_vm._v("that’s ")]), _vm._v("where the switch was,” Tommy said. “I couldn’t find it. I’m glad you’re here—”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-01-8"
    }
  }, [_c('span', [_vm._v("Dr. Ghieri blocked the exit. “What are you doing?” he said coldly.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-01-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“As I was about to explain,” Tommy said, slurring his words, “I was looking for a computer. I can’t get Wi-Fi, so I gotta hardwire to a")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v(" computer to download a file from my accountant because apparently the underwriters are having some sort of conniption fit that has to be straightened out before the IPO next month . . .”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-01-1"
    }
  }, [_c('span', [_vm._v("“What are you doing?” Ghieri repeated.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-01-2"
    }
  }, [_c('span', [_vm._v("“As I was saying,” Tommy said, smiling as he held up the USB jack to the listening device draped around his neck, “I didn’t think you’d mind, but . . . you guys really need to get a Wi-Fi setup if you—”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-01-3"
    }
  }, [_c('span', [_vm._v("Ghieri stepped forward and grabbed Tommy by the throat. His grip was like iron as his hand closed around Tommy’s windpipe and lifted him off the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-01-4"
    }
  }, [_c('span', [_vm._v("Tommy weighed 220 pounds, but the man raised him as if he were holding up a dandelion to blow away the seeds. Tommy tried in vain to pry the smaller man’s hand from his throat.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-01-5"
    }
  }, [_c('span', [_vm._v("Ghieri grabbed the wire around Tommy’s neck, examined it for a moment, then snapped it as easily as breaking a dry spaghetti noodle. He pulled Tommy closer until their faces were inches apart. His breath smelled sulfurous and putrid. His eyes were penetrating and blank, windows not into a soul but into the absence of one.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-01-6"
    }
  }, [_c('span', [_vm._v("Tommy struggled to free himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-01-7"
    }
  }, [_c('span', [_vm._v("Ghieri heard something.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-01-8"
    }
  }, [_c('span', [_vm._v("Startled, he spun around, lifting Tommy even higher. Pinning him against the wall with one hand, Ghieri listened. Tommy couldn’t breathe.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-01-9"
    }
  }, [_c('span', [_vm._v("Then Ghieri simply wasn’t there anymore.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-01-10"
    }
  }, [_c('span', [_vm._v("Tommy dropped to the floor.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-01-11"
    }
  }, [_c('span', [_vm._v("He rubbed his throat and gasped desperately for air, coughing. He managed to rise to one knee.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-01-12"
    }
  }, [_c('span', [_vm._v("Something picked him up and gently lifted him to his feet.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-01-13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("He turned to see a burly man in a tuxedo, with a close-cropped beard and long hair pulled back in a ponytail. He wore an earring in his left ear and had a tattoo of a cross on the back of his right hand. Tommy had last seen this man the night he’d gone to Bull’s Rock Hill hoping to find out")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v(" why Julie Leonard had been murdered—only that night the man had been dressed in biker attire. The “biker” had revealed himself to be an angel and said his name was Charlie.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-1"
    }
  }, [_c('span', [_vm._v("“Are you all right?” Charlie asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-2"
    }
  }, [_c('span', [_vm._v("“I’m okay.” Tommy rubbed his throat. He looked around. “Where did he go?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-3"
    }
  }, [_c('span', [_vm._v("“That’s not a question I can answer, but he’ll be back. I thought you could use some help.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-4"
    }
  }, [_c('span', [_vm._v("Tommy saw a small red object, marked by a white cross, in Charlie’s hand. “From a Swiss Army knife?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-5"
    }
  }, [_c('span', [_vm._v("“It has multiple attachments.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-6"
    }
  }, [_c('span', [_vm._v("Standing this close to the angel, Tommy couldn’t think of what to say. The air had a kind of excitement to it, an ozone smell, as if lightning had just struck, or would any second.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-7"
    }
  }, [_c('span', [_vm._v("“I know,” Tommy said. “I have one.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-8"
    }
  }, [_c('span', [_vm._v("“Can it do this?” the angel said. He opened a small blade and pointed it toward the ceiling. As Tommy watched, it transformed into a large sword, radiating a bright white light that forced Tommy to shield his eyes with his hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-9"
    }
  }, [_c('span', [_vm._v("The light became flame, swirling toward the ceiling in beautiful, flickering tongues. Then, just as suddenly as it appeared, the flames were extinguished. The light went out and the blade shrank back into the angel’s hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-10"
    }
  }, [_c('span', [_vm._v("“No,” Tommy said. “Mine can’t do that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-11"
    }
  }, [_c('span', [_vm._v("He knew somehow that what the angel had chosen to show him was only a partial display, a hint at the full extent of his power.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-12"
    }
  }, [_c('span', [_vm._v("There were a hundred questions Tommy wanted to ask, but this wasn’t the time. He had to get back to Dani. Knowing her, she’d be looking for him. The bug he’d hoped to plant was useless, but he shoved the pieces into his pocket lest someone find them and take a closer look.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-13"
    }
  }, [_c('span', [_vm._v("“What should I do if he comes back?”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-14"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“When a demon is in physical form, it feels pain,” the angel said. “You")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v(" can’t kill them—humans can’t—but you can drive them off. They operate in the shadows. The pure light of God is harsh to them. It burns them. And they don’t like to draw attention because they know we might come to defeat them. I have to go. But you’re on the right track.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-01-1"
    }
  }, [_c('span', [_vm._v("Tommy blinked, and the angel was gone.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-01-2"
    }
  }, [_c('span', [_c('i', [_vm._v("Next time")]), _vm._v(", he told himself, "), _c('i', [_vm._v("don’t blink")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-606f3edf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter6.vue
// module id = 87
// module chunks = 0